import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  "Shoes": "https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20photography%20of%20designer%20sneakers%20on%20a%20warm%20sand%20colored%20background%20with%20soft%20diffused%20afternoon%20light%20casting%20subtle%20gentle%20shadows%20clean%20crisp%20details%20premium%20composition%20sophisticated%20European%20lifestyle%20aesthetic&width=60&height=60&seq=nav-shoes-01&orientation=squarish",
  "Hoodies/Sweaters": "https://readdy.ai/api/search-image?query=Minimal%20product%20photography%20of%20a%20premium%20beige%20hoodie%20on%20a%20light%20stone%20gray%20surface%20with%20soft%20natural%20window%20light%20subtle%20texture%20details%20clean%20European%20aesthetic%20cozy%20refined%20style&width=60&height=60&seq=nav-hoodies-01&orientation=squarish",
  "T-Shirts": "https://readdy.ai/api/search-image?query=Clean%20product%20shot%20of%20a%20white%20organic%20cotton%20tshirt%20on%20a%20warm%20ivory%20background%20with%20natural%20indirect%20daylight%20soft%20minimal%20composition%20modern%20Scandinavian%20aesthetic%20fresh%20and%20pure%20style&width=60&height=60&seq=nav-tshirts-01&orientation=squarish",
  "Jackets": "https://readdy.ai/api/search-image?query=Stylish%20product%20photography%20of%20a%20modern%20lightweight%20jacket%20on%20a%20soft%20oatmeal%20colored%20surface%20with%20gentle%20side%20lighting%20subtle%20creases%20elegant%20casual%20style%20European%20fashion%20aesthetic&width=60&height=60&seq=nav-jackets-01&orientation=squarish",
  "Pants/Shorts": "https://readdy.ai/api/search-image?query=Minimal%20product%20shot%20of%20tailored%20casual%20pants%20on%20a%20warm%20greige%20background%20with%20soft%20natural%20light%20clean%20lines%20modern%20European%20style%20refined%20relaxed%20aesthetic&width=60&height=60&seq=nav-pants-01&orientation=squarish",
  "Headwear": "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20stylish%20baseball%20cap%20on%20a%20soft%20stone%20colored%20surface%20with%20gentle%20diffused%20light%20minimal%20shadow%20crisp%20details%20modern%20lifestyle%20aesthetic&width=60&height=60&seq=nav-headwear-01&orientation=squarish",
  "Sets": "https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20coordinated%20two%20piece%20clothing%20set%20on%20a%20warm%20taupe%20background%20with%20soft%20natural%20lighting%20harmonious%20composition%20modern%20European%20aesthetic%20refined%20style&width=60&height=60&seq=nav-sets-01&orientation=squarish",
  "underwear/underpants": "https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20shot%20of%20premium%20underwear%20on%20a%20soft%20warm%20ecru%20background%20with%20gentle%20diffused%20light%20subtle%20texture%20elegant%20understated%20style%20modern%20European%20photography&width=60&height=60&seq=nav-underwear-01&orientation=squarish",
  "Jersey": "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20premium%20sports%20jersey%20on%20a%20light%20warm%20gray%20surface%20with%20soft%20natural%20lighting%20vibrant%20color%20accents%20modern%20athletic%20aesthetic%20European%20style&width=60&height=60&seq=nav-jersey-01&orientation=squarish",
  "Accessories": "https://readdy.ai/api/search-image?query=Minimal%20product%20photography%20of%20elegant%20fashion%20accessories%20on%20a%20soft%20sand%20colored%20background%20with%20gentle%20lighting%20refined%20composition%20modern%20luxury%20aesthetic%20subtle%20sophistication&width=60&height=60&seq=nav-accessories-01&orientation=squarish",
  "Bags": "https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20shot%20of%20a%20premium%20designer%20handbag%20on%20a%20light%20warm%20stone%20surface%20with%20soft%20natural%20light%20clean%20shadows%20modern%20European%20style%20refined%20luxury%20aesthetic&width=60&height=60&seq=nav-bags-01&orientation=squarish",
  "Belts": "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20premium%20leather%20belt%20on%20a%20soft%20ivory%20background%20with%20gentle%20side%20lighting%20subtle%20grain%20texture%20minimal%20composition%20modern%20sophisticated%20style&width=60&height=60&seq=nav-belts-01&orientation=squarish",
  "Perfumes": "https://readdy.ai/api/search-image?query=Elegant%20product%20shot%20of%20a%20luxury%20perfume%20bottle%20on%20a%20warm%20cream%20surface%20with%20soft%20diffused%20light%20subtle%20reflections%20refined%20composition%20modern%20European%20aesthetic%20sophisticated%20style&width=60&height=60&seq=nav-perfumes-01&orientation=squarish",
  "Other Stuff": "https://readdy.ai/api/search-image?query=Minimal%20product%20photography%20of%20various%20premium%20lifestyle%20accessories%20on%20a%20soft%20warm%20beige%20background%20with%20gentle%20natural%20lighting%20clean%20composition%20modern%20casual%20European%20aesthetic&width=60&height=60&seq=nav-other-01&orientation=squarish",
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);
  const [guideDropdownOpen, setGuideDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!dropdownOpen && !guideDropdownOpen) return;

    const handler = () => {
      setDropdownOpen(false);
      setGuideDropdownOpen(false);
    };

    const timer = setTimeout(() => {
      document.addEventListener('click', handler);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handler);
    };
  }, [dropdownOpen, guideDropdownOpen]);

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setGuideDropdownOpen(false);
    setDropdownOpen(!dropdownOpen);
  };

  const toggleGuideDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDropdownOpen(false);
    setGuideDropdownOpen(!guideDropdownOpen);
  };

  const guideLinks = [
    { label: 'Einsteiger Guide', slug: 'oopbuy-spreadsheet-einsteiger' },
    { label: 'Zoll & Steuern', slug: 'zoll-steuern-oopbuy-spreadsheet' },
    { label: 'QC-Prozess', slug: 'qc-prozess-oopbuy-spreadsheet' },
    { label: 'Preisvergleich', slug: 'oopbuy-spreadsheet-preisvergleich' },
    { label: 'Sneaker Guide', slug: 'oopbuy-spreadsheet-sneaker-guide' },
    { label: 'Versand Guide', slug: 'oopbuy-spreadsheet-versand-deutschland' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-[4.25rem]">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
          >
            <span className="text-lg md:text-xl font-heading font-semibold text-foreground-900 tracking-tight">
              oopbuyspread<span className="text-primary-500">.</span>living
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
            >
              <i className="ri-home-line"></i>
              Startseite
            </Link>

            <div className="relative">
              <button
                onClick={toggleDropdown}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Kategorien</span>
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-72 bg-background-50 rounded-xl border border-background-200/70 py-2 shadow-sm z-50 max-h-96 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-primary-50 transition-colors cursor-pointer"
                    >
                      <div className="w-9 h-9 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                        <img
                          src={categoryImages[cat.name]}
                          alt={cat.nameDe}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <span className="whitespace-nowrap">{cat.nameDe}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div className="relative">
              <button
                onClick={toggleGuideDropdown}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                <span>Einkaufsguide</span>
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${guideDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {guideDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-56 bg-background-50 rounded-xl border border-background-200/70 py-2 shadow-sm z-50">
                  {guideLinks.map((guide) => (
                    <Link
                      key={guide.slug}
                      to={`/guides/${guide.slug}`}
                      onClick={() => {
                        setGuideDropdownOpen(false);
                        window.scrollTo({ top: 0, behavior: 'instant' });
                      }}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {guide.label}
                    </Link>
                  ))}
                  <div className="border-t border-background-200/70 mt-1 pt-1">
                    <Link
                      to="/#guides"
                      onClick={() => setGuideDropdownOpen(false)}
                      className="block px-4 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Alle Guides anzeigen →
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <a
              href="/#warum"
              className="px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Warum Oopbuy
            </a>
            <a
              href="/#bewertungen"
              className="px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Bewertungen
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              oopbuy spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1.5"
            >
              buy it now
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="Menü öffnen"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="flex items-center gap-2 px-3 py-3 text-sm font-semibold rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-home-line"></i>
              Startseite
            </Link>

            <div>
              <button
                onClick={() => setMobileCategoryOpen(!mobileCategoryOpen)}
                className="w-full flex items-center justify-between px-3 py-3 text-sm font-semibold rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-grid-line"></i>
                  Kategorien
                </span>
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${mobileCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {mobileCategoryOpen && (
                <div className="ml-2 mt-1 grid grid-cols-2 gap-1">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileMenuOpen(false)}
                      className="flex items-center gap-2 px-2 py-2 rounded-lg text-sm text-foreground-600 hover:text-foreground-900 hover:bg-primary-50 transition-colors cursor-pointer"
                    >
                      <div className="w-8 h-8 rounded-md overflow-hidden flex-shrink-0 bg-background-100">
                        <img
                          src={categoryImages[cat.name]}
                          alt={cat.nameDe}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <span className="text-xs leading-tight">{cat.nameDe}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div>
              <span className="block px-3 py-2 text-xs font-semibold uppercase tracking-wider text-foreground-400 mt-2">
                Einkaufsguide
              </span>
              {guideLinks.map((guide) => (
                <Link
                  key={guide.slug}
                  to={`/guides/${guide.slug}`}
                  onClick={() => {
                    setMobileMenuOpen(false);
                    window.scrollTo({ top: 0, behavior: 'instant' });
                  }}
                  className="flex items-center gap-2 px-3 py-2.5 text-sm rounded-lg text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <i className="ri-article-line text-xs"></i>
                  {guide.label}
                </Link>
              ))}
              <Link
                to="/#guides"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-2 px-3 py-2.5 text-sm rounded-lg text-primary-600 hover:text-primary-700 hover:bg-primary-50 transition-colors font-medium cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xs"></i>
                Alle Guides
              </Link>
            </div>

            <a href="/#warum" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm font-semibold rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-information-line"></i>
              Warum Oopbuy
            </a>
            <a href="/#bewertungen" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-2 px-3 py-3 text-sm font-semibold rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-star-line"></i>
              Bewertungen
            </a>

            <div className="pt-3 flex flex-col gap-2 border-t border-background-200/70 mt-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-3 text-sm font-medium rounded-lg bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                oopbuy spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full px-4 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer flex items-center justify-center gap-1.5"
              >
                buy it now
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}